// Tailwindを使う案件だけ有効化
// import "../styles/tailwind.css";
import "yakuhanjp/dist/css/yakuhanrp.css";
import "../styles/style.scss";
import { initContactForm } from "./components/contact-form.js";
import { initServiceIllustrations } from "./components/service-illustration.js";
import { initServiceMarquees } from "./components/service-marquee.js";
import { initServicePoints } from "./components/service-points.js";
import { initServiceSliders } from "./components/service-slider.js";
import { initStaffSliders } from "./components/staff-slider.js";
import { initTableScroll } from "./components/table-scroll.js";
import { initTopHero } from "./components/top-hero.js";
import { initTopMap } from "./components/top-map.js";
import { initTopScrollBubbles } from "./components/top-notice.js";
import { initVoices } from "./components/voice.js";
import { initHeader } from "./layouts/header.js";

initHeader();
initContactForm();
initTableScroll();
initTopHero();
initTopMap();
initTopScrollBubbles();
initServiceIllustrations();
initServiceMarquees();
initServicePoints();
initServiceSliders();
initStaffSliders();
initVoices();

document.body.classList.add("is-shown");
